export default "__VITE_PUBLIC_ASSET__1f73304b__"